var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrFreeBets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.708 19.778h14.583a.486.486 0 000-.973H4.708a.486.486 0 000 .973zM19.291 15.889H4.708a.486.486 0 010-.973h14.583a.486.486 0 010 .973zM10.796 11.858a.488.488 0 00.689 0l4.868-4.861a.486.486 0 10-.688-.689l-4.524 4.518L9.549 9.24a.486.486 0 00-.687.688l1.934 1.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.82 23.666h22.36a.486.486 0 00.486-.486V.82a.486.486 0 00-.736-.418l-2.955 1.774L16.37.384a.491.491 0 00-.421-.006L12.045 2.19 8.372.383A.488.488 0 007.95.379L4.105 2.18 1.065.4a.487.487 0 00-.732.42v22.36c0 .269.218.486.486.486zm21.874-.972H1.305V1.668l2.53 1.48c.138.081.305.09.451.021l3.866-1.81 3.672 1.807a.492.492 0 00.42.004l3.902-1.811 3.634 1.806a.486.486 0 00.466-.018l2.448-1.47v21.017z"
  })));
}
SvgPrFreeBets.displayName = 'PrFreeBets';
export default SvgPrFreeBets;